import dayjs from "dayjs";

export const formatDateTime = (date) => {
  if (!date) return "";
  return dayjs(date).format("YYYY-MM-DD HH:mm:ss");
};

export const formatPrice = (price) => {
  if (!price) return "";
  return price.toLocaleString("ko-KR");
};

export const formatPoint = (point) => {
  if (!point) return "";
  return point.toLocaleString("ko-KR");
};

export const formatRefundStatus = (status) => {
  switch (status) {
    case "CANCEL_REFUND_COMPLETED_DD":
      return "주문취소 환불완료";
    case "RETURN_REFUND_COMPLETED_DD":
      return "반품 환불완료";
  }
  return "-";
};

export const formatRefundMethod = (method) => {
  switch (method) {
    case "PERSONAL":
      return "신용카드 (취소)";
    case "COMPANY":
      return "법인카드 (취소)";
    case "ACCOUNT":
      return "무통장 입금";
  }
  return "-";
};

export const orderClassificationText = (classification) => {
  switch (classification) {
    case "MANUAL_ONE_DAY_MALL":
      return "수동(원데이몰)";
    case "AUTOMATIC_INVENTORY":
      return "자동(재고)";
    case "MANUAL_INVENTORY":
      return "수동(재고)";
    default:
      break;
  }
  return "-";
};

export const productOrderStatusText = (status) => {
  switch (status) {
    case "DEPOSIT_WAITING":
      return "입금대기";
    case "PAYMENT_COMPLETED":
      return "결제완료";
    case "CANCELED":
      return "취소";
    case "SHIPPING":
      return "배송중";
    case "DELIVERY_COMPLETED":
      return "배송완료";
    case "PURCHASE_CONFIRMED":
      return "구매확정";
    case "EXCHANGED":
      return "교환";
    case "EXCHANGED_SHIPPING":
      return "교환배송중";
    case "EXCHANGED_SHIPPING_OFFICE":
      return "교환배송(본사)";
    case "EXCHANGED_FINISH":
      return "교환배송완료";
    case "RETURNED":
      return "반품";
    case "RETURNED_SHIPPING":
      return "반품배송중";
    case "RETURNED_FINISH":
      return "반품배송완료";
    default:
      break;
  }

  return "-";
};

export const productOrderParentStatusText = (status) => {
  switch (status) {
    case "DRAFTED":
      return "임시저장";
    case "IN_PROGRESS":
      return "진행중";
    case "COMPLETED":
      return "완료";
    case "CANCELED":
      return "취소";
    default:
      break;
  }

  return "-";
};
